
import vehicleData from './data/additionalVehicles.json';

/**
 * 
 * @param {*} vehicles : this should be an array of vehicles returned by response
 */
export const createVehiclesConfirmation = (vehicles) => {
    console.log('vehicles confirmation');
    return{
        type: 'CREATE_VEHICLES_CONFIRMATION_LIST',
        payload: addVehiclesToList(vehicles)
    }
}

/**
 * addVehiclesToList: add additional vehicles to the list that are wrong
 */
const addVehiclesToList = (vehicles) => {
    console.log('add additional vehicles');
    
    vehicles = [...vehicles, ...vehicleData]

    vehicles.forEach(element => {
        element.uniqueId = `${element.make}::${element.model}::${element.year}`;
    });

    console.log(vehicles);

    return vehicles;
    
}

export const findVehicleByUniqueID = (vehicleSearchTerms) => {
    console.log(vehicleSearchTerms);
    return {
        type: 'SEARCH_FOR_UNIQUE_VEHICLES'
    }
}

export const validateVehicleSelection = () => {
    return{
        type: 'VALIDATE_VEHICLE_SELECTION',
        payload: 'validate selection'
    }
}

export const setQuoteEstimate = (estimate) => {
    return {
        type: 'SET_QUOTE_ESTIMATE',
        payload: estimate
    }
}


// WEBPACK FOOTER //
// ./src/Confirm/actions.js